import React from 'react';
import tpcLogo from "../../../images/TPC-logo-light.png";
import './TermsModal.css';

const TermsModal = ({ isOpen, onClose, type }) => {
  if (!isOpen) return null;

  const termsContent = {
    terms: {
      title: "Terms and Conditions",
      content: `
        <h3>1. Acceptance of Terms</h3>
        <p>By accessing and using the Hero Dashboard, you accept and agree to be bound by the terms and provision of this agreement.</p>
        
        <h3>2. Use License</h3>
        <p>Permission is granted to temporarily access the Hero Dashboard for personal, non-commercial transitory viewing only.</p>
        
        <h3>3. User Responsibilities</h3>
        <p>You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.</p>
        
        <h3>4. Data Protection</h3>
        <p>We are committed to protecting your personal information and will handle it in accordance with our Privacy Policy.</p>
        
        <h3>5. Intellectual Property</h3>
        <p>The content, features, and functionality of the Hero Dashboard are owned by TPC Group and are protected by international copyright, trademark, and other intellectual property laws.</p>
        
        <h3>6. Limitation of Liability</h3>
        <p>TPC Group shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Hero Dashboard.</p>
        
        <h3>7. Modifications</h3>
        <p>We reserve the right to modify these terms at any time. Continued use of the service constitutes acceptance of any changes.</p>
        
        <h3>8. Contact Information</h3>
        <p>For questions about these Terms and Conditions, please contact us at support@tpc.training</p>
      `
    },
    privacy: {
      title: "Privacy Policy",
      content: `
        <h3>1. Information We Collect</h3>
        <p>We collect information you provide directly to us, such as when you create an account, including your name, email address, and role information.</p>
        
        <h3>2. How We Use Your Information</h3>
        <p>We use the information we collect to provide, maintain, and improve our services, communicate with you, and ensure security.</p>
        
        <h3>3. Information Sharing</h3>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy.</p>
        
        <h3>4. Data Security</h3>
        <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
        
        <h3>5. Data Retention</h3>
        <p>We retain your personal information for as long as necessary to provide our services and comply with legal obligations.</p>
        
        <h3>6. Your Rights</h3>
        <p>You have the right to access, update, or delete your personal information. You may also request a copy of your data or withdraw consent.</p>
        
        <h3>7. Cookies and Tracking</h3>
        <p>We use cookies and similar technologies to enhance your experience and analyze usage patterns.</p>
        
        <h3>8. Changes to This Policy</h3>
        <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
        
        <h3>9. Contact Us</h3>
        <p>If you have questions about this Privacy Policy, please contact us at privacy@tpc.training</p>
      `
    }
  };

  const currentContent = termsContent[type];

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-background">
          <img src={tpcLogo} alt="TPC Logo" className="terms-modal-logo" />
        </div>
        
        <div className="terms-modal-header">
          <h2 className="terms-modal-title">{currentContent.title}</h2>
          <button className="terms-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="terms-modal-content">
          <div 
            className="terms-modal-text"
            dangerouslySetInnerHTML={{ __html: currentContent.content }}
          />
        </div>
        
        <div className="terms-modal-footer">
          <button className="terms-modal-button" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal; 